export default __webpack_public_path__ + "static/media/features4.2f9970dc.svg";